const { userAgent: ua, vendor } = navigator;
const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
const isWindowsPhone = /Windows Phone/.test(ua);
const isAndroid = /android/i.test(ua);
const supportsPointerEvents = "PointerEvent" in window;
const supportsTouchEvents = "ontouchstart" in window;
let supportsPassiveEvents = false;
try {
  const options = Object.defineProperty({}, "passive", {
    get: () => {
      supportsPassiveEvents = true;
      return true;
    }
  });
  window.addEventListener("testPassive", null, options);
  window.removeEventListener("testPassive", null, options);
} catch (err) {
}
var platform_default = {
  isAndroid,
  isApple: /Apple/.exec(vendor),
  isEdge: /Edge\/1[2-9]\./.test(ua),
  isIE: /Trident/.test(ua),
  isIOS,
  isIPhone: /iPhone|iPod/.test(ua) && !window.MSStream,
  isSafari: /^((?!chrome|android).)*safari/i.test(ua),
  isLinux: /^(?!.*android).*linux.*$/i.test(ua),
  isMobile: isIOS || isWindowsPhone || isAndroid,
  isNrknoApp: /^NRK NO/.test(navigator.userAgent) || /[&?]viewContext=/.test(window.location && window.location.search),
  isWindowsDesktop: /Windows NT/.test(ua),
  isWindowsPhone,
  pointerEventTypes: supportsPointerEvents ? {
    enter: "pointerenter",
    down: "pointerdown",
    leave: "pointerleave",
    move: "pointermove",
    over: "pointerover",
    out: "pointerout",
    up: "pointerup"
  } : {
    enter: "mouseenter",
    down: supportsTouchEvents ? "touchstart" : "mousedown",
    leave: "mouseleave",
    move: supportsTouchEvents ? "touchmove" : "mousemove",
    over: "mouseover",
    out: "mouseout",
    up: supportsTouchEvents ? "touchend" : "mouseup"
  },
  supportsPointerEvents,
  supportsPassiveEvents
};
export {
  platform_default as default
};
